<template>
    <div>
        <ul v-if="formIsReadOnly" class="readonly-tag-list">
            <li v-for="item in selectedItems" :key="item.TopicId" class="readonly-tag">
                <span class="readonly-tag-title">{{ item.Title }}</span>
            </li>
        </ul>
        <div v-else>
            <ul class="tag-list">
                <li v-for="item in selectedItems" :key="item.TopicId" class="tag">
                    <span class="tag-title">{{ item.Title }}</span>
                    <button class="tag-remove" @click="removeItem(item)">
                        <i class="fa-regular fa-circle-xmark"></i>
                    </button>
                </li>
                <li class="tag tag-add" @click="openPopup">
                    <i class="fa-solid fa-plus"></i>
                </li>
            </ul>

            <!-- Unsichtbare DxNumberBox für den Range-Validator -->
            <DxNumberBox :value="selectedItems.length"
                         :readOnly="true"
                         :element-attr="{ class: 'crmValidationBox' }"
                         class="hidden-validator">
                <DxValidator>
                    <DxRangeRule :min="computedMinLength"
                                 :max="computedMaxLength"
                                 type="range"
                                 :message="config.RangeMessage" />
                </DxValidator>
            </DxNumberBox>

            <DxPopup v-model:visible="isPopupVisible"
                     title="Please Select"
                     :width="500"
                     :height="auto"
                     :show-close-button="true"
                     @hidden="onClosed">
                <div class="popup-content">
                    <div class="search-container">
                        <DxTextBox placeholder="Search..."
                                   :show-clear-button="true"
                                   class="search-box"
                                   :buttons="[
                        {
                            name: 'search',
                            location: 'after',
                            options: {
                                icon: 'fa-solid fa-magnifying-glass',
                                stylingMode: 'text'
                            }
                        },
                        {
                            name: 'reset',
                            location: 'after',
                            options: {
                                icon: 'fa-solid fa-xmark',
                                stylingMode: 'text',
                                onClick: resetSearch
                            }
                        }
                    ]"
                                   @input="onSearchInput">
                        </DxTextBox>
                    </div>
                    <DxDataGrid ref="dataGridRef"
                                :data-source="topicList"
                                :key-expr="'TopicId'"
                                :selection="{ mode: 'multiple', showCheckBoxesMode: 'always', selectAllMode: 'allPages', allowSelectAll: true }"
                                :scrolling="{ mode: 'virtual' }"
                                :paging="{ enabled: false }"
                                v-model:selected-row-keys="selectedRowKeys"
                                height="400px"
                                width="100%">
                        <DxColumn data-field="TopicId" caption="ID" width="100" />
                        <DxColumn data-field="Title" caption="Title" />
                    </DxDataGrid>
                    <div class="popup-footer">
                        <DxButton text="Select" type="default" @click="confirmSelection" />
                    </div>
                </div>
            </DxPopup>

        </div>
    </div>
</template>


<script>
    import { ref, computed, watch } from 'vue';
    import { DxTextBox } from 'devextreme-vue/text-box';
    import { DxPopup } from 'devextreme-vue/popup';
    import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
    import { DxButton } from 'devextreme-vue/button';
    import axios from 'axios';

    export default {
        name: 'TopicLinkSelectList',
        components: {
            DxPopup,
            DxDataGrid,
            DxColumn,
            DxButton,
            DxTextBox
        },
        props: {
            modelValue: {
                type: Array,
                required: true,
            },
            formIsReadOnly: {
                type: Boolean,
                required: true,
            },
            config: {
                type: Object,
                required: true,
            },
            matId: {
                type: Number,
                required: true, // MatId ist erforderlich
            },
        },
        setup(props, { emit }) {
            const topicList = ref([]);
            const selectedRowKeys = ref([]);
            const isPopupVisible = ref(false);
            const dataGridRef = ref(null); // Referenz auf das DxDataGrid

            const selectedItems = computed({
                get: () => props.modelValue,
                set: (value) => {
                    console.log(value, props.matId)
                    emit('update:modelValue', value);
                },
            });
            const onClosed = () => {
                emit('closed', props.modelValue);
            };

            const loadTopics = async () => {
                if (!props.matId) return;

                try {
                    const response = await axios.get(`WebApi.asmx/api/applicationService/GetTopicListForMatId?matId=${props.matId}`);
                    if (response.data && response.data.success && response.data.topicList) {
                        topicList.value = response.data.topicList.map((topic) => ({
                            ...topic,
                            selected: props.modelValue && props.modelValue.some((item) => item.TopicId === topic.TopicId),
                        }));
                        selectedRowKeys.value = props.modelValue ? props.modelValue.map((item) => item.TopicId) : [];
                    }
                } catch (error) {
                    console.error('Error loading topics:', error);
                }
            };


            const resetSearch = () => {
                if (dataGridRef.value) {
                    dataGridRef.value.instance.searchByText(''); // Leert die Suche im Grid
                }
            };

            const onSearchInput = (e) => {
                if (dataGridRef.value) {
                    dataGridRef.value.instance.searchByText(e.event.target.value); // Setzt den Suchtext im Grid
                }
            };

            const openPopup = () => {
                isPopupVisible.value = true;
            };

            const confirmSelection = () => {
                if (!topicList.value || !selectedRowKeys.value) return;

                selectedItems.value = topicList.value.filter((topic) => {
                    if (!topic || !topic.TopicId) return false;
                    return selectedRowKeys.value.includes(topic.TopicId);
                });

                isPopupVisible.value = false;
            };

            const removeItem = (item) => {
                if (!item || !item.TopicId || !selectedItems.value) return;

                selectedItems.value = selectedItems.value.filter((i) => i.TopicId !== item.TopicId);
            };

            watch(
                () => props.matId,
                (newMatId) => {
                    if (newMatId) {
                        loadTopics();
                    }
                },
                { immediate: true }
            );

            return {
                topicList,
                selectedRowKeys,
                isPopupVisible,
                dataGridRef,
                selectedItems,
                openPopup,
                confirmSelection,
                removeItem,
                onSearchInput,
                resetSearch,
                onClosed
            };
        },
    };
</script>


<style scoped>

    .search-container {
        margin-bottom: 10px;
    }

    .search-box {
        width: 100%;
    }

    .dx-button[name="search"] {
        color: #ea7034;
    }

        .dx-button[name="search"]:hover {
            color: #00a4e0;
        }

    .hidden-validator {
        visibility: hidden; /* Element bleibt im DOM, ist aber unsichtbar */
        height: 0; /* Platzverbrauch minimieren */
        overflow: hidden;
    }

    .tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 5px; /* Abstand zwischen den Tags */
        list-style: none;
        padding: 0;
        margin: 0;
        justify-content: flex-start; /* Links ausgerichtet */
    }

    .tag {
        display: flex;
        align-items: center;
        background: white;
        border: 1px solid silver;
        border-radius: 5px;
        padding: 10px 10px;
    }

        .tag i::before {
            font-size: 17px;
        }

    li.tag-add {
        padding: 0;
    }

    #app li.tag {
        margin: 0;
    }

    .tag-title {
        margin-right: 5px;
    }

    .tag-remove {
        background: none;
        border: none;
        cursor: pointer;
        color: #ea7034;
    }

        .tag-remove:hover {
            color: #00a4e0;
        }

    .tag-add {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px; /* Breite des quadratischen Icons */
        height: 40px; /* Höhe des quadratischen Icons */
        border: 1px solid silver;
        border-radius: 5px;
        background-color: white;
        cursor: pointer;
        color: #ea7034;
    }

        .tag-add:hover {
            color: #00a4e0;
            background-color: #f5f5f5;
        }

        .tag-add i {
            font-size: 20px; /* Größe des Icons */
            margin: 0; /* Entfernt jeglichen Abstand */
        }

    .readonly-tag-list {
        padding: 0; /* Entfernt den Standard-Innenabstand */
        margin: 0; /* Entfernt den Standard-Außenabstand */
        text-align: left; /* Stellt sicher, dass der Text linksbündig ist */
    }
</style>
